import React from "react";
import { array, func } from "prop-types";

import { Icon } from "../../atoms/icon";
import "./filter-pills.m.css";

export const FilterPills = ({
  selectedRegions = [],
  onRemoveFilter,
  ...props
}) => {
  if (selectedRegions.length === 0) {
    return null;
  }

  return (
    <div styleName="filter-pills" {...props}>
      {selectedRegions.map((region) => (
        <div key={region} styleName="filter-pill">
          <span styleName="pill-text">{region}</span>
          <button
            type="button"
            styleName="pill-remove"
            onClick={() => onRemoveFilter && onRemoveFilter(region)}
            aria-label={`Remove ${region} filter`}
          >
            <Icon name="close" size="xsmall" />
          </button>
        </div>
      ))}
    </div>
  );
};

FilterPills.propTypes = {
  selectedRegions: array,
  onRemoveFilter: func
};